import * as Yup from "yup";
import { IDistributor } from "../../Components/hg-settings/subscriptions/add-plan-modal/modal-form/add-distributor-dropdown";
import { ModuleData } from "../../Components/hg-settings/subscriptions/add-plan-modal/modal-form/modules-table/modules.mock-data";

export interface IDistributorPricing {
  distributor: IDistributor;
  currency: string;
  costPeriod: string;
  costValue: string;
  marginPercent: string;
  pricePeriod: string;
}

export interface IAddPlanFormValues {
  planName: string;
  usersCount: string | number;
  modules: ModuleData[];
  distributors: IDistributorPricing[];
}

export const addPlanValidationSchema = Yup.object().shape({
  planName: Yup.string().required("Plan name is required"),
  usersCount: Yup.mixed()
    .test("is-number", "Users count must be a number", (value) => {
      if (value === "" || value === null || value === undefined) return false;
      const num = typeof value === "string" ? Number.parseFloat(value) : Number(value);
      return !isNaN(num) && num > 0;
    })
    .required("Users count is required"),
  modules: Yup.array().of(
    Yup.object().shape({
      label: Yup.string().required(),
      unitLabel: Yup.string().required(),
      isChecked: Yup.boolean().required(),
      userCount: Yup.number().min(0).required(),
      limitType: Yup.string().oneOf(["Limited", "Unlimited"]).required(),
    })
  ),
  distributors: Yup.array().of(
    Yup.object().shape({
      distributor: Yup.object().shape({
        id: Yup.string().required(),
        name: Yup.string().required(),
        image: Yup.string().required(),
      }).required(),
      currency: Yup.string().required("Currency is required"),
      costPeriod: Yup.string().required("Cost period is required"),
      costValue: Yup.string()
        .required("Cost value is required")
        .test("is-number", "Cost value must be a valid number", (value) => {
          if (!value) return false;
          const num = Number.parseFloat(value);
          return !isNaN(num) && num >= 0;
        }),
      marginPercent: Yup.string()
        .required("Margin percent is required")
        .test("is-number", "Margin percent must be a valid number", (value) => {
          if (!value) return false;
          const num = Number.parseFloat(value);
          return !isNaN(num) && num >= 0;
        }),
      pricePeriod: Yup.string().required("Price period is required"),
    })
  ),
});

export const getAddPlanFormInitialValues = (modules: ModuleData[]): IAddPlanFormValues => ({
  planName: "",
  usersCount: 15,
  modules: modules.map((module) => ({ ...module })),
  distributors: [],
});

